import { createReducer, on } from "@ngrx/store";
import { FirstPartiesOutput } from "../models/FirstParties";
import { ModifiedFirstPartiesActions } from "../actions";

export const modifiedFirstPartiesKey = "firstPartiesOutput";

export interface State extends ModifiedFirstPartiesList { }

interface ModifiedFirstPartiesList {
  firstPartyPayees: FirstPartiesOutput[]
}
export const initialModifiedFirstPartiesState: State = {
  firstPartyPayees: [] 
}

export const modifiedFirstPartiesReducer = createReducer(
  initialModifiedFirstPartiesState,
  on(ModifiedFirstPartiesActions.getModifiedFirstPartiesSuccess, (state, action) => {
    const { response } = action;
    return {
      ...state,
      firstPartyPayees: response.firstPartyPayees
    };
  }),
  on(ModifiedFirstPartiesActions.getModifiedFirstPartiesFailure, _state => {
    return initialModifiedFirstPartiesState;
  })
)